// redux/actions/ciudades/types.js
export const FETCH_CIUDADES_SUCCESS = "FETCH_CIUDADES_SUCCESS";
export const FETCH_CIUDADES_FAILURE = "FETCH_CIUDADES_FAILURE";
